import {Translate} from 'react-redux-i18n';

import {Icon, Tabs as CoreTabs} from 'front-onceforall-core';

import {useClientDetailsStore} from '../ClientDetailsStore';

const buildTabItemLabel = item => (
  <div>
    <Translate value={item.text}/>
    {item.loading && <Icon icon="loader"/>}
    {!item.loading && Number.isInteger(item.counter) &&
      <span className="separator">{item.counter}</span>
    }
  </div>
);

function Tabs() {
  const {tabItems} = useClientDetailsStore().state;

  return (
    <div style={{backgroundColor: '#f5f5f5', margin: '0 -45px 30px', padding: '0 45px'}}>
      <CoreTabs
        items={tabItems.map(item => ({
          ...item,
          label: buildTabItemLabel(item)
        }))}
      />
    </div>
  );
}

export default Tabs;
